import React from "react";

const STATUS_META = {
  draft: { label: "Draft", tone: "muted" },
  submitted: { label: "Submitted", tone: "info" },
  under_review: { label: "Under Review", tone: "info" },
  clarification_required: { label: "Action Required", tone: "warning" },
  estimate_in_preparation: { label: "Preparing Estimate", tone: "info" },
  estimate_ready: { label: "Estimate Ready", tone: "primary" },
  awaiting_decision: { label: "Awaiting Decision", tone: "primary" },
  revision_requested: { label: "Revision Requested", tone: "warning" },
  revised_quote_ready: { label: "Revised Quote Ready", tone: "primary" },
  awaiting_payment: { label: "Awaiting Payment", tone: "primary" },
  payment_processing: { label: "Processing Payment", tone: "info" },
  paid: { label: "Paid", tone: "success" },
  in_production: { label: "In Production", tone: "info" },
  quality_review: { label: "Quality Review", tone: "info" },
  quality_rework: { label: "Rework in Progress", tone: "warning" },
  ready_for_delivery: { label: "Ready for Delivery", tone: "success" },
  ready: { label: "Ready to Download", tone: "success" },
  delivered: { label: "Delivered", tone: "success" },
  completed: { label: "Completed", tone: "success" },
  replacement_requested: { label: "Replacement Requested", tone: "warning" },
  replacement_in_progress: { label: "Replacement in Progress", tone: "info" },
  replacement_delivered: { label: "Replacement Delivered", tone: "success" },
  declined: { label: "Declined", tone: "destructive" },
  cancelled: { label: "Cancelled", tone: "muted" },
};

const TONES = {
  muted:      "bg-muted text-muted-foreground border-border",
  info:       "bg-blue-50 text-blue-800 border-blue-200",
  primary:    "bg-primary/10 text-primary border-primary/30",
  success:    "bg-emerald-50 text-emerald-800 border-emerald-200",
  warning:    "bg-amber-50 text-amber-900 border-amber-300",
  destructive:"bg-red-50 text-red-800 border-red-200",
};

export default function StatusPill({ status, size = "sm" }) {
  const meta = STATUS_META[status] || { label: status?.replace(/_/g, " "), tone: "muted" };
  const cls = TONES[meta.tone];
  const sizeCls = size === "lg" ? "text-sm px-3 py-1.5" : "text-[11px] px-2.5 py-1";
  return (
    <span data-testid={`status-pill-${status}`} className={`inline-flex items-center gap-1.5 font-medium border ${cls} ${sizeCls} rounded-sm tracking-tight`}>
      <span className={`h-1.5 w-1.5 rounded-full ${meta.tone === "muted" ? "bg-muted-foreground" : "bg-current"}`} />
      {meta.label}
    </span>
  );
}

export { STATUS_META };
